import React, { useState } from "react"
import Select, { components } from "react-select"
import { UilAngleDown } from "@iconscout/react-unicons"
import { changeLocale, injectIntl } from "gatsby-plugin-intl"

const options = [
  { value: "it", label: "Italiano", icon: "italy" },
  { value: "en", label: "English", icon: "united-kingdom" },
  { value: "es", label: "Español", icon: "spain" },
  { value: "de", label: "Deutsche", icon: "germany" },
  { value: "fr", label: "Français", icon: "france" },
]
const langSelectStyle = {
  control: styles => ({
    ...styles,
    backgroundColor: "white",
    border: 0,
    boxShadow: "0px 5px 15px #00000019",
    borderRadius: "7px",
  }),
  indicatorSeparator: styles => ({ display: "none" }),
  container: styles => ({
    ...styles,
    fontSize: "12px",
    fontFamily: "Montserrat",
    fontWeight: 600,
    color: "#102342",
  }),
  menu: styles => ({ ...styles, border: 0 }),
}

const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <UilAngleDown />
    </components.DropdownIndicator>
  )
}

const SingleValue = ({ children, data, ...props }) => {
  return (
    <components.SingleValue {...props}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <img
          src={`/flags/${data.icon}.svg`}
          alt=""
          style={{ width: "16px", height: "16px", marginRight: "7px" }}
        />
        {children}
      </div>
    </components.SingleValue>
  )
}

const LanguageSelect = ({ intl }) => {
  const [defaultValue] = useState(
    options.find(lang => lang.value === intl.locale)
  )

  return (
    <Select
      options={options}
      styles={langSelectStyle}
      value={defaultValue}
      components={{ DropdownIndicator, SingleValue }}
      placeholder={`${intl.formatMessage({ id: "terms.language" })}...`}
      onChange={lang => {
        changeLocale(lang.value)
      }}
      isSearchable={false}
      theme={theme => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: "#004b93",
          primary75: "#3b82f5",
          primary25: "#CEDCF5",
        },
      })}
    />
  )
}

const LanguageSelectMobile = ({ intl }) => {
  const activeStyle = {
    border: "3px solid rgba(255,255,255, 0.2)",
    borderRadius: "100%",
  }
  return options.map(option => {
    const style = option.value === intl.locale ? activeStyle : {}
    return (
      <img
        src={`/flags/${option.icon}.svg`}
        alt=""
        key={option.value}
        style={{ width: "30px", height: "30px", padding: "3px", ...style }}
        onClick={() => changeLocale(option.value)}
      />
    )
  })
}

const LanguageSelectIntl = injectIntl(LanguageSelect)
const LanguageSelectMobileIntl = injectIntl(LanguageSelectMobile)

export {
  LanguageSelectIntl as LanguageSelect,
  LanguageSelectMobileIntl as LanguageSelectMobile,
}
